package org.chiangmeng.qfast.core.ui.staff

import org.chiangmeng.qfast.core.domain.models.AppTheme
import org.chiangmeng.qfast.core.domain.models.QueueTicket
import org.chiangmeng.qfast.core.domain.models.Shop
import org.chiangmeng.qfast.core.domain.models.QueueHistoryItem

class StaffContract {
    data class State(
        val shop: Shop? = null,
        val queues: List<QueueTicket> = emptyList(),
        val isLoading: Boolean = false,
        val currentTheme: AppTheme = AppTheme.AMBER,
        val history: List<QueueHistoryItem> = emptyList(),
        val errorMessage: String? = null,
        val isAccountDeleted: Boolean = false,
        val newlyIssuedTicket: QueueTicket? = null
    )

    sealed class Intent {
        data class LoadData(val shopId: String) : Intent()
        data class NextQueue(val category: String) : Intent()
        data class IssueTicket(val category: String) : Intent()
        object ResetQueue : Intent()
        data class UpdateShopInfo(
            val name: String,
            val adText: String,
            val menuUrl: String,
            val openTime: String,
            val closeTime: String,
            val theme: String
        ) : Intent()
        data class UpdateCategories(val categories: Map<String, String>) : Intent()
        data class ChangeTheme(val theme: AppTheme) : Intent()
        data class UpdateShopStatus(val isActive: Boolean) : Intent()
        data class CompleteQueue(val shopId: String, val ticketNumber: Int) : Intent()
        data class RecallQueue(val shopId: String, val ticketNumber: Int) : Intent()
        data class SkipQueue(val shopId: String, val ticketNumber: Int) : Intent()
        data class DeleteAccount(val onSuccess: () -> Unit) : Intent()
        data class SignOut(val onSuccess: () -> Unit) : Intent()
        data class PrintSpecificTicket(val ticket: QueueTicket) : Intent()
        object DismissTicketDialog : Intent()
        object ClearNewlyIssuedTicket : Intent()
        data class SelectTicketForQr(val ticket: QueueTicket) : Intent()
    }
}
